var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "日期格式" } },
        [
          _c(
            "el-select",
            {
              staticClass: "setting-date-format",
              model: {
                value: _vm.dateFormat,
                callback: function($$v) {
                  _vm.dateFormat = $$v
                },
                expression: "dateFormat"
              }
            },
            [
              _c("el-option", {
                attrs: { value: "yyyy-MM-dd", label: "yyyy-MM-dd" }
              }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { value: "yyyy/MM/dd", label: "yyyy/MM/dd" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08423ff7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08423ff7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingDateFormat.vue
// module id = null
// module chunks = 